<template>
  <div class="record-com">
    <div class="com-top flex-row justify-between">
      <div class="top-handle flex-middle" @click="handleAdd">
        <img :src="require('@/assets/img/guessing-management/icon-add.png')" />
      </div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="申请时间：">
          <el-date-picker
            @change="changeDate"
            v-model="formInline.time"
            class="dataTimer"
            type="daterange"
            size="medium"
            range-separator="-"
            prefix-icon="el-icon-date"
            popper-class="dateTimer-droper"
            :clearable="true"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <!--
        <el-form-item>
          <el-button @click="getListInfo" class="select-btn" plain>查询</el-button>
        </el-form-item>
				-->
      </el-form>
    </div>

    <el-table
      border
      :data="tableData"
      :row-style="{ height: '50px', fontSize: '14px' }"
      :cell-style="{ padding: 0 }"
      :header-row-style="tableHeaderRow"
      :header-cell-style="tableHeaderColor"
      v-loading="loading"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" type="index" width="80"> </el-table-column>
      <el-table-column prop="title" label="预设问题" align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="contentArr[0]" label="A选项" align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="contentArr[1]" label="B选项" align="center" :show-overflow-tooltip="true"> </el-table-column>
      <el-table-column label="关联直播" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ scope.row.comp }} {{ scope.row.match_title }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="minBetFormat" label="最小投注额" align="center" :show-overflow-tooltip="true"> </el-table-column>

      <el-table-column label="状态" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span style="color: #3c9cfe" v-if="scope.row.status == 1">审核中</span>
          <span style="color: #333333" v-else-if="scope.row.status == 2">已通过</span>
          <el-tooltip v-else-if="scope.row.status == 3" class="item" effect="dark" :content="'审核意见：' + scope.row.reason" placement="top">
            <span style="color: #db6372; cursor: pointer"> 拒绝 </span>
          </el-tooltip>

          <span v-else></span>
        </template>
      </el-table-column>

      <el-table-column prop="create_time" label="申请时间" align="center" width="180px" :show-overflow-tooltip="true"> </el-table-column>

      <el-table-column prop="reason" label="审核建议" align="center" :show-overflow-tooltip="true"> </el-table-column>

      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <div class="handler-panel flex-middle">
            <!--
					<img :src="require('@/assets/img/guessing-management/icon-yes.png')"/>
					-->
            <img :src="require('@/assets/img/guessing-management/icon-copy.png')" @click="handleClone(scope.row)" />
            <img :src="require('@/assets/img/guessing-management/icon-delete.png')" @click="handleDelete(scope.row)" />
          </div>
        </template>
      </el-table-column>

      <div slot="empty" class="search_list">
        <div class="list_body">
          <div class="empty_content">
            <!-- <img src="https://test-1301875615.cos.ap-beijing.myqcloud.com/images/20211013094041773982020-12-15%2021.33.14.jpg"
                 alt="" />
            <div class="empty_text">暂无任何记录哦～</div>
            -->
            <Empty text="暂时没有消费数据" :imgWidth="250" :img="require('@/assets/img/empty/consume.png')"></Empty>
          </div>
        </div>
      </div>
    </el-table>

    <div class="pagination_bottom">
      <el-pagination background layout="prev, pager, next" :page-size="info.size" :total="totalCount" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="info.page">
      </el-pagination>
    </div>

    <AddQuestionDialog ref="AddQuestionDialog" @refresh="getListInfo"></AddQuestionDialog>
    <EditQuestionDialog ref="EditQuestionDialog" @refresh="getListInfo"></EditQuestionDialog>
    <DeleteAlertDialog title="确定删除该问题吗？" @commit="deleteQuestion" ref="DeleteAlertDialog"></DeleteAlertDialog>
    <CloneAlertDialog title="确定复制该问题吗？" @commit="cloneQuestion" ref="CloneAlertDialog"></CloneAlertDialog>
  </div>
</template>

<script>
import { post } from "../../util/http";
import { mapState } from "vuex";
import moment from "moment";
import Empty from "@/components/empty/empty";
import AddQuestionDialog from "@/components/dialog/AddQuestionDialog";
import EditQuestionDialog from "@/components/dialog/EditQuestionDialog";
import DeleteAlertDialog from "@/components/dialog/AlertDialog";
import CloneAlertDialog from "@/components/dialog/AlertDialog";
export default {
  components: {
    Empty,
    AddQuestionDialog,
    EditQuestionDialog,
    DeleteAlertDialog,
    CloneAlertDialog,
  },
  data() {
    return {
      moment: moment,
      loading: false,
      formInline: {
        anchor_id: "",
        time: [],
      },
      tableData: [],
      info: {
        page: 1,
        size: 8,
      },
      totalCount: 0,
    };
  },
  props: {},
  computed: {
    ...mapState(["userInfo"]),
  },
  created() {
    console.log(this.userInfo);
  },
  mounted() {
    this.$nextTick(() => {
      let keyNode = document.querySelector(".el-date-editor");
      console.log(keyNode);
      if (!keyNode) return;
      /*
      let iNode = document.createElement("i");
      iNode.setAttribute("class", "el-icon-date"); // el-icon-bottom
      keyNode.appendChild(iNode);

      iNode.style.position = "absolute";
      iNode.style.top = "13px";
      iNode.style.right = "13px";
      */
      this.getListInfo();
    });
  },
  filters: {
    formatData: (value) => {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      let m = date.getMinutes();
      let s = date.getSeconds();
      h = h < 10 ? "0" + h : h;
      m = m < 10 ? "0" + m : m;
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + "" + h + ":" + m + ":" + s;
    },
  },
  methods: {
    handleAdd() {
      this.$refs.AddQuestionDialog.open();
    },

    handleDelete(item = {}) {
      this.$refs.DeleteAlertDialog.open(item);
    },

    handleClone(item = {}) {
      // console.log("item: ",item)
      // this.$refs.CloneAlertDialog.open(item);
      this.$refs.EditQuestionDialog.open(item);
    },

    deleteQuestion({ id = "" }) {
      if (!id) {
        return;
      }
      let data = {
        q_id: id,
      };
      post({
        url: "/api/guess/delQuestion",
        data,
      })
        .then(({ data: { data, status = "" } }) => {
          if (status == 0) {
            this.$message({
              message: "删除成功",
              type: "success",
              customClass: "ly-success",
            });
            this.getListInfo();
          } else {
            this.$message({
              message: "删除失败",
              type: "error",
              customClass: "ly-error",
            });
          }
        })
        .catch((err) => {
          this.$message({
            message: "删除失败",
            type: "error",
            customClass: "ly-error",
          });
        });
    },

    cloneQuestion(item = {}) {
      let data = {
        content: item.content || "",
        item_num: item.item_num || 0,
        match_id: item.match_id,
        match_title: item.match_title || "",
        min_bet: item.min_bet || 0,
        title: item.title,
      };
      // console.log("data: ",data)

      post({
        url: "/api/guess/createQuestion",
        data,
      })
        .then(({ data: { data, status = "" } }) => {
          // console.log("data: ",data);
          if (status == 0) {
            this.$message({
              message: "复制成功",
              type: "success",
              customClass: "ly-success",
            });
            this.getListInfo();
          } else {
            this.$message({
              message: "复制失败",
              type: "error",
              customClass: "ly-error",
            });
          }
        })
        .catch((err) => {
          this.$message({
            message: "复制失败",
            type: "error",
          });
          console.warn("createQuestion err: ", err);
        });
    },

    changeDate(item) {
      // console.log("item: ",item);
      this.getListInfo();
    },
    handleSizeChange(val) {
      this.$set(this.info, "size", val);
      // console.log(`每页 ${val} 条`);
      this.selectList();
    },

    handleCurrentChange(val) {
      this.$set(this.info, "page", val);
      //console.log(`当前页: ${val}`);
      this.getListInfo();
    },

    getListInfo() {
      this.loading = true;
      let data = {
        anchor_id: this.userInfo.id,
        status: 0,
        page: this.info.page,
        size: this.info.size,
      };
      if (this.formInline.time && this.formInline.time.length) {
        //data.t_end = String(new Date(this.formInline.time[1]).getTime() / 1000) || "";
        //data.t_start = String(new Date(this.formInline.time[0]).getTime() / 1000) || "";
        data.t_end = this.formInline.time[1] + " 23:59:59" || "";
        data.t_start = this.formInline.time[0] + " 00:00:00" || "";
      }
      // console.log(data)
      post({
        url: "/api/guess/getQuestionList",
        data,
      })
        .then(({ data: { data } }) => {
          const list = data?.question ?? ["", ""];
          list.forEach((v) => {
            v.contentArr = v.content?.split("|");
            v.minBetFormat = v?.min_bet / 100 || 0;
          });
          // console.log("list: ",list);
          this.tableData = list;
          this.totalCount = data.total;
          setTimeout(() => {
            this.loading = false;
          }, 20);
          // this.$emit('backCount', data.count)
        })
        .catch((err) => {
          setTimeout(() => {
            this.loading = false;
          }, 20);
        });
    },

    // 设置表头颜色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      // return 'background-color: #c7e7e2;color:#526e6e;font-size: 14px;font-weight:600; height: 36px;padding: 0px'
      return `
				background-color:#02A8A2;
				color:#ffffff;
				font-size: 14px;
				font-weight:600; 
				height: 36px;
				padding: 0px";
				border : 0px;
			 `;
    },

    tableHeaderRow() {
      //return 'height: 36px'
      return `
				height:56px;
				letter-spacing:1px;
				border-radius : 20px;
			`;
    },

    // handleSizeChange(val) {
    // 	console.log(`每页 ${val} 条`);
    // },
    // handleCurrentChange(val) {
    // 	console.log(`当前页: ${val}`);
    // }
  },
};
</script>

<style lang="stylus" scoped>
.record-com{
	/deep/{
		.el-range__close-icon{
			right : 40px !important;
			z-index : 1000;
		}
		.el-range-editor--medium .el-range__close-icon, .el-range-editor--medium .el-range__icon{
			position : absolute;
			right : 10px;
			justify-content: center;
			display: flex;
			align-items: center;
		}
	 .el-icon-date:before {
			content: "";
			background: url(../../assets/img/guessing-management/date.png) no-repeat;
			background-size: 100% auto;
			display: block;
			width: 18px;
			height: 18px;
		}
		.el-table{
			// border : 0px;
			border-top-left-radius: 13px;
			border-top-right-radius: 13px;
		}
		.el-pagination{
			padding : 30px 0px;
		}
		.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
			color : #02A8A2;
			background : #ffffff;
			border : 1px solid #DBDBDB;
		}
		.el-pagination.is-background .el-pager li:not(.disabled).active{
			background : #02A8A2;
			color : #ffffff;
			border-color : #02A8A2;
		}
	}

	.com-top{
		.top-handle{
			img {
				height : 22px;
				margin : 0px 5px;
				cursor : pointer;
			}
		}
	}
	.handler-panel{
		img {
			height : 17px;
			margin : 0px 5px;
			cursor : pointer;
		}
	}
	.pagination_bottom {
			padding: 10px;
			display: flex;
			justify-content: center;
	}
}
</style>
